import { useEffect } from 'react'
import Breadcrumb from '../../core/components/UI/Breadcrumb'
import { useOpportunitiesContext } from '../context/opportunities/OpportunitiesProvider'
import useOpportunitiesActions from '../hooks/useOpportunitiesActions'
import ButtonShowModalOpportunities from '../components/opportunities-page/ButtonShowModalOpportunities'
import ButtonOpportunitiesOptions from '../components/opportunities-page/ButtonOpportunitiesOptions'

const links = [
  {
    id: 1,
    label: `الفرص الاستثمارية`,
    isActive: true,
    to: '/countries/opportunities',
  },
]

export default function OpportunitiesPage() {
  const { opportunitiesState } = useOpportunitiesContext()
  const { getCountries } = useOpportunitiesActions()

  useEffect(() => {
    getCountries()
  }, [])

  return (
    <>
      <Breadcrumb links={links} />
      <div className="flex items-center justify-between"></div>
      {opportunitiesState.isLoading ? (
        <div className="grid animate-pulse grid-cols-12 gap-2">
          {[...Array(21)].map((_, index) => (
            <div
              key={index}
              className="col-span-12 lg:col-span-6 xl:col-span-4"
            >
              <div
                className={`flex h-14 border-2 border-muted-500 bg-white p-2`}
              ></div>
            </div>
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-12 gap-2">
          {opportunitiesState.countries.map((country) => (
            <div className="col-span-12 lg:col-span-6 xl:col-span-4">
              <div
                className={`flex justify-between gap-2 border-2 border-muted-500 bg-white p-2`}
              >
                <div className="relative flex items-center gap-2">
                  <img
                    alt={country?.name_ar}
                    src={`${process.env.REACT_APP_API_BASE_URL}/storage/flags/${country?.image}`}
                    className="w-14 border-2 border-muted-500"
                  />
                  <h2 className="line-clamp-1 text-sm font-bold">
                    {country?.name_ar}
                  </h2>
                </div>
                <div className="flex gap-2">
                  <ButtonShowModalOpportunities country={country} />
                  <ButtonOpportunitiesOptions country={country} />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  )
}
